var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",on:{"click":function($event){return _vm.$emit('aoClicarCard')}}},[_c('h4',[_vm._v(_vm._s(_vm.titulo))]),_c('p',[_vm._v(_vm._s(_vm.descricao))])])
}
var staticRenderFns = []

export { render, staticRenderFns }